export const FREQUENCIES = [
  'semanal', 'quincenal', 'mensual', 'proyecto', 'extemporal',
];

export const STATUSES = ['borrador', 'aprobado', 'pagado', 'cancelado'];

// Only the frequencies that imply a computable number of days. 'proyecto' and
// 'extemporal' are absent on purpose: their base salary is captured by hand.
export const FREQUENCY_DAYS = { semanal: 7, quincenal: 15, mensual: 30 };

const pad = (value) => String(value).padStart(2, '0');

/**
 * ISO week number of a date. Written out rather than pulled from a library
 * because it is eight lines and the project has no date dependency.
 */
const isoWeek = (date) => {
  const target = new Date(Date.UTC(
    date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()
  ));
  // Thursday decides which year and week a date belongs to under ISO 8601.
  const dayNumber = (target.getUTCDay() + 6) % 7;
  target.setUTCDate(target.getUTCDate() - dayNumber + 3);
  const firstThursday = new Date(Date.UTC(target.getUTCFullYear(), 0, 4));
  const firstDayNumber = (firstThursday.getUTCDay() + 6) % 7;
  firstThursday.setUTCDate(firstThursday.getUTCDate() - firstDayNumber + 3);
  return 1 + Math.round((target - firstThursday) / (7 * 86400000));
};

/**
 * Options for the Period select, given the chosen frequency.
 *
 * Weeks and fortnights are scoped to the current month - a 52-entry week list
 * is unusable in a plain select - but the stored code always carries the ISO
 * week or fortnight number *of the year*, so two periods in different years
 * can never collide.
 */
export const buildPeriodOptions = (frequency, referenceDate = new Date()) => {
  const year = referenceDate.getUTCFullYear();
  const month = referenceDate.getUTCMonth(); // 0-based

  if (frequency === 'semanal') {
    const options = [];
    const seen = new Set();
    const daysInMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();

    for (let day = 1; day <= daysInMonth; day += 1) {
      const week = isoWeek(new Date(Date.UTC(year, month, day)));
      if (seen.has(week)) continue;
      seen.add(week);
      options.push({ value: `${year}-W${pad(week)}`, label: `W${pad(week)}` });
    }
    return options;
  }

  if (frequency === 'quincenal') {
    const first = month * 2 + 1;
    return [first, first + 1].map((index) => ({
      value: `${year}-B${pad(index)}`,
      label: `B${pad(index)}`,
    }));
  }

  if (frequency === 'mensual') {
    return Array.from({ length: 12 }, (_unused, index) => ({
      value: `${year}-M${pad(index + 1)}`,
      label: `M${pad(index + 1)}`,
    }));
  }

  if (frequency === 'proyecto') {
    return [{ value: `${year}-P`, label: 'P' }];
  }

  if (frequency === 'extemporal') {
    return [{ value: `${year}-EX`, label: 'EX' }];
  }

  return [];
};
